import { createSlice } from "@reduxjs/toolkit";

const mapSlice = createSlice({
  name: "map",
  initialState: {
    mapBounds: {
      north: 0,
      south: 0,
      east: 0,
      west: 0,
    }, // Store map boundaries
    mapZoom: 10, // Default zoom level
    mapCenter: {
      lat: 0,
      lng: 0,
    },
    activeMarkerId: null,
  },
  reducers: {
    setMapBounds: (state, action) => {
      state.mapBounds = action.payload;
    },
    setMapZoom: (state, action) => {
      state.mapZoom = action.payload;
    },
    setMapCenter: (state, action) => {
      if (
        state.mapCenter.lat === action.payload.lat &&
        state.mapCenter.lng === action.payload.lng
      ) {
        return state; // avoid unnecessary state updates. floating-point precision with .toJSON()
      }
      state.mapCenter = action.payload;
    },
    setActiveMarkerId: (state, action) => {
      state.activeMarkerId = action.payload;
    },
  },
});

export default mapSlice;
